import { ENotificationType } from '../../Model/ENotificationType';
import { ENotificationAction } from './NotificationAction';

export enum EModalNotificationAction {
  SEND_MODAL_NOTIFICATION = "SEND_MODAL_NOTIFICATION",
  REMOVE_MODAL_NOTIFICATION = "REMOVE_MODAL_NOTIFICATION",
}
export interface ModalNotificationAction {
  type: EModalNotificationAction;
  modalNotifications?: {
    type: ENotificationType;
    headerText:string;
    bodyTitleText:string;
    bodySubTitleText:string;
    onClickOk?:() => void;
    onClickCancel?:() => void;
    okLabel?:string;
    cancleLabel?:string;
  };
}

export function sendModalNotification(
    type: ENotificationType, 
    headerText: string,
    bodyTitleText: string,
    bodySubTitleText: string,
    onClickOk?:() => void,
    onClickCancel?:() => void,
    okLabel?: string,
    cancleLabel?: string,): ModalNotificationAction {
  return {
    type: EModalNotificationAction.SEND_MODAL_NOTIFICATION,
    modalNotifications: {
        type: type,
        headerText:headerText,
        bodyTitleText:bodyTitleText,
        bodySubTitleText:bodySubTitleText,
        onClickOk:onClickOk,
        onClickCancel:onClickCancel,
        okLabel:okLabel,
        cancleLabel:cancleLabel,
    },
  };
}

export function removeModalNotification(): ModalNotificationAction {
  return {
    type: EModalNotificationAction.REMOVE_MODAL_NOTIFICATION,
  };
}
